import React, { useEffect, useState } from 'react';
import Header from '../../../../components/Header';
import { useNavigate, useParams } from 'react-router-dom';
import NavigationTabsCustomersDetails from './NavigationTabsCustomersDetails';
import Information from './informations';
import { toast } from 'react-toastify';
import {
	changeCustomerStatus,
	createCustomer,
	deleteCustomer,
	getCustomerDetail,
	updateCustomer,
} from '../../../../../services/customers';
import DeleteModal from '../../../components/deleteModal';
import ConfirmationModal from '../../../../../component/modal/ConfirmationModal';
import { useDispatch, useSelector } from 'react-redux';
import { master_data } from '../../../../../store/action/master';
import { getCities } from '../../../../../services/vendor';
import { hasPermission, newObjectCreater } from '../../../../../utils/controller';
import RenderContent from './renderContent';
import PageLoader from '../../../../../component/PageLoader';

const CustomersDetails = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const [isNotEdit, setIsNotEdit] = useState(true);
	const [isClone, setIsClone] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const [isMarkAsStatusModel, setIsMarkAsStatusModel] = useState(false);
	const param = useParams();
	const dispatch = useDispatch();
	const id = param?.id;
	const [activeTab, setActiveTab] = useState('Information');
	const [errors, setError] = useState({});
	const [projectTitle, setProjectTitle] = useState('Customer Details');
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [prescriptionsDocsList, setPrescriptionsDocsList] = useState([]);
	const [cityList, setCityList] = useState([]);
	const [totalOutStandingAmount, setTotalOutStandingAmount] = useState(0);
	const [amountDueFifteenDays, setAmountDueFifteenDays] = useState(0);
	const [customerData, setCustomerData] = useState({
		basicDetails: {
			customer_type: 0,
			customer_name: '',
			company_name: '',
			customer_display_name: '',
			customer_email: '',
			customer_phone_mobile: '',
			customer_phone_work: '',
			customer_credit_days: 0,
			status: 0,
			customer_business_id: null,
		},
		othersDetails: {
			pan_number: '',
			gst_number: '',
			currency: 'INR',
			is_enable_portal: false,
		},
		address: {
			attention: '',
			country_id: '',
			street_1: '',
			street_2: '',
			city_id: null,
			state_id: null,
			zip_code: '',
		},
		customerRemark: {
			remark_text: '',
		},
		can_delete: null,
	});
	const [customerDocs, setCustomerDocs] = useState({
		gstDocs: null,
		adhaarDocs: null,
		panDocs: null,
		drugLicenseDocs: null,
		fssaiDocs: null,
	});

	async function getCustomerDetails() {
		try {
			setLoader(true);
			var { customer_details } = await getCustomerDetail(id);
			setCustomerData({
				basicDetails: {
					customer_type: Number(customer_details?.type),
					customer_name: customer_details?.name,
					company_name: customer_details?.customer_business?.name,
					customer_display_name: customer_details?.display_name,
					customer_email: customer_details?.email,
					customer_phone_mobile: customer_details?.mobile,
					customer_phone_work: customer_details?.phone,
					customer_credit_days: customer_details?.credit_days,
					status: customer_details?.status,
					...(customer_details?.type === 1
						? { customer_business_id: customer_details?.customer_business?.id }
						: {}),
				},
				othersDetails: {
					gst_number: customer_details?.customer_business?.gst_number,
					pan_number: customer_details?.pan,
					currency: customer_details?.currency,
					is_enable_portal: customer_details?.is_enable_portal,
				},
				address: {
					attention: customer_details?.attention,
					country_id: customer_details?.country_id,
					street_1: customer_details?.street1,
					street_2: customer_details?.street2,
					city_id: customer_details?.city_id,
					state_id: customer_details?.state_id,
					zip_code: customer_details?.zipcode,
				},
				customerRemark: {
					remark_text: customer_details?.remarks,
				},
				can_delete: customer_details?.can_delete,
			});
			setTotalOutStandingAmount(customer_details?.total_outstanding || '0');
			setAmountDueFifteenDays(customer_details?.due_in_next_15_days || '0');

			setCustomerDocs({
				gstDocs:
					customer_details?.documents.filter((data) => data.type === 'gst_doc') === undefined
						? null
						: customer_details?.documents.filter((data) => data.type === 'gst_doc')[0],
				adhaarDocs:
					customer_details?.documents.filter((data) => data.type === 'aadhar_card_doc') ===
					undefined
						? null
						: customer_details?.documents.filter((data) => data.type === 'aadhar_card_doc')[0],
				panDocs:
					customer_details?.documents.filter((data) => data.type === 'pan_doc') === undefined
						? null
						: customer_details?.documents.filter((data) => data.type === 'pan_doc')[0],
				drugLicenseDocs:
					customer_details?.documents.filter((data) => data.type === 'drug_license_doc') ===
					undefined
						? null
						: customer_details?.documents.filter((data) => data.type === 'drug_license_doc')[0],
				fssaiDocs:
					customer_details?.documents.filter((data) => data.type === 'fssai_doc') === undefined
						? null
						: customer_details?.documents.filter((data) => data.type === 'fssai_doc')[0],
			});
			setPrescriptionsDocsList(
				customer_details?.documents.filter((data) => data.type === 'prescription_doc') === undefined
					? null
					: customer_details?.documents.filter((data) => data.type === 'prescription_doc'),
			);
		} catch (err) {
			toast.error(err || 'something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	function handleCreateButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `invoices-create`,
			1: baseUrl + `payments-received-create`,
			2: baseUrl + `sales-return-create`,
			3: baseUrl + `sales/credit-note-create`,
		};

		navigate(urlMap[Number(index)], {
			state: { key: Number(id), value: customerData?.basicDetails.customer_name },
		});
	}

	const checkValidation = () => {
		var error = { ...errors };
		if (
			!customerData.basicDetails.customer_name ||
			customerData.basicDetails.customer_name === undefined ||
			customerData.basicDetails.customer_name === ''
		) {
			error.customer_name = 'Please enter customer name in the field';
		} else {
			delete error.customer_name;
		}

		if (customerData.basicDetails.customer_type === 1) {
			if (
				!customerData.basicDetails.company_name ||
				customerData.basicDetails.company_name === undefined ||
				customerData.basicDetails.company_name === ''
			) {
				error.company_name = 'Please enter company name in the field';
			} else {
				delete error.company_name;
			}
		} else {
			delete error.company_name;
		}
		if (
			!customerData.basicDetails.customer_display_name ||
			customerData.basicDetails.customer_display_name === undefined ||
			customerData.basicDetails.customer_display_name === ''
		) {
			error.customer_display_name = 'Please enter customer display name in the field';
		} else {
			delete error.customer_display_name;
		}
		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	const handleCloneCustomer = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Unable to clone customer');
		} else {
			setLoading(true);
			const formData = new FormData();
			const customerObj = {
				type: customerData.basicDetails.customer_type,
				status: status,
				name: customerData.basicDetails.customer_name,
				display_name: customerData.basicDetails.customer_display_name,
				email: customerData.basicDetails.customer_email,
				phone: customerData.basicDetails.customer_phone_work,
				mobile: customerData.basicDetails.customer_phone_mobile,
				credit_days: customerData.basicDetails.customer_credit_days,
				is_enable_portal: customerData.othersDetails.is_enable_portal,
				attention:
					customerData.address.attention !== '' && customerData.address.attention !== null
						? customerData.address.attention
						: '',
				country_id:
					customerData.address.country_id !== '' && customerData.address.country_id !== null
						? customerData.address.country_id
						: '',
				city_id:
					customerData.address.city_id !== '' && customerData.address.city_id !== null
						? customerData.address.city_id
						: '',
				street1:
					customerData.address.street_1 !== '' && customerData.address.street_1 !== null
						? customerData.address.street_1
						: '',
				street2:
					customerData.address.street_2 !== '' && customerData.address.street_2 !== null
						? customerData.address.street_2
						: '',
				state_id:
					customerData.address.state_id !== '' && customerData.address.state_id !== null
						? customerData.address.state_id
						: '',
				zipcode:
					customerData.address.zip_code !== '' && customerData.address.zip_code !== null
						? customerData.address.zip_code
						: '',
			};
			for (const key in customerObj) {
				formData.append(key, customerObj[key]);
			}

			if (customerData.basicDetails.company_name && customerData.basicDetails.customer_type === 1) {
				var business_info = {
					company_name: customerData.basicDetails.company_name,
					...(customerData.othersDetails.gst_number
						? { gst_number: customerData.othersDetails.gst_number }
						: {}),
				};
				formData.append('customer_business', JSON.stringify(business_info));
			}
			if (customerData.othersDetails.pan_number) {
				formData.append('pan', customerData.othersDetails.pan_number);
			}
			if (customerData.othersDetails.currency) {
				formData.append('currency', customerData.othersDetails.currency);
			}
			if (customerData.customerRemark.remark_text) {
				formData.append('remarks', customerData.customerRemark.remark_text);
			}

			if (customerDocs.gstDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('gst_doc', customerDocs.gstDocs);
			}
			if (customerDocs.drugLicenseDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('drug_lisence_doc', customerDocs.drugLicenseDocs);
			}
			if (customerDocs.fssaiDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('fssai_doc', customerDocs.fssaiDocs);
			}
			if (customerDocs.adhaarDocs) {
				formData.append('aadhar_card_doc', customerDocs.adhaarDocs);
			}

			prescriptionsDocsList.forEach((pdoc) => {
				formData.append('prescription_doc', pdoc?.imagePath);
			});

			if (customerDocs.panDocs) {
				formData.append('pan_doc', customerDocs.panDocs);
			}
			try {
				const res = await createCustomer(formData);
				if (res?.success) {
					toast.success(res?.message);
					setTimeout(() => {
						navigate(`/user/${suburl}/customers`);
					}, 300);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	const handleUpdateCustomer = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Unable to update customer');
		} else {
			setLoading(true);

			var body = {
				type: customerData.basicDetails.customer_type,
				status: status,
				name: customerData.basicDetails.customer_name,
				display_name: customerData.basicDetails.customer_display_name,
				email: customerData.basicDetails.customer_email,
				phone: customerData.basicDetails.customer_phone_work,
				mobile: customerData.basicDetails.customer_phone_mobile,
				credit_days: customerData.basicDetails.customer_credit_days,
				is_enable_portal: customerData.othersDetails.is_enable_portal,

				attention:
					customerData.address.attention !== '' && customerData.address.attention !== null
						? customerData.address.attention
						: '',
				country_id:
					customerData.address.country_id !== '' && customerData.address.country_id !== null
						? customerData.address.country_id
						: '',
				city_id:
					customerData.address.city_id !== '' && customerData.address.city_id !== null
						? customerData.address.city_id
						: '',
				street1:
					customerData.address.street_1 !== '' && customerData.address.street_1 !== null
						? customerData.address.street_1
						: '',
				street2:
					customerData.address.street_2 !== '' && customerData.address.street_2 !== null
						? customerData.address.street_2
						: '',
				state_id:
					customerData.address.state_id !== '' && customerData.address.state_id !== null
						? customerData.address.state_id
						: '',
				zipcode:
					customerData.address.zip_code !== '' && customerData.address.zip_code !== null
						? customerData.address.zip_code
						: '',
			};

			if (customerData.basicDetails.company_name && customerData.basicDetails.customer_type === 1) {
				var comapnyName = {
					company_name: customerData.basicDetails.company_name,
					gst_number: customerData.othersDetails.gst_number,
				};
				body['customer_business'] = comapnyName;
			}

			if (customerData.othersDetails.pan_number) {
				body['pan'] = customerData.othersDetails.pan_number;
			}
			if (customerData.othersDetails.currency) {
				body['currency'] = customerData.othersDetails.currency;
			}
			if (customerData.customerRemark.remark_text) {
				body['remarks'] = customerData.customerRemark.remark_text;
			}

			try {
				const res = await updateCustomer(body, id);
				if (res?.success) {
					toast.success(res?.message);
					navigate(`/user/${suburl}/customers`);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	async function handleBulkDelete() {
		try {
			var body = JSON.stringify({
				ids: [id],
			});
			await deleteCustomer(body);
			toast.success('Customer Deleted Successfully.');
			setIsDeleteModalOpen(false);
			navigate(`/user/${suburl}/customers`);
		} catch (error) {
			toast.error(error?.response?.data?.message);
			setIsDeleteModalOpen(false);
			navigate(`/user/${suburl}/customers`);
		}
	}

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark customer as{' '}
					{customerData.basicDetails.status === 1 ? 'Inactive' : 'Active'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{`1.${customerData.basicDetails.customer_name}`}
				</div>
			</div>
		);
	};

	const getModalTitle = () => {
		if (customerData.basicDetails.status === 1) {
			return 'Mark as Inactive Customers';
		} else if (customerData.basicDetails.status === 2) {
			return 'Mark as Active Customers';
		}
		return 'Confirm Action';
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				ids: [id],
				status: status,
			};
			setLoader(true);
			await changeCustomerStatus(formbody);
			toast.success('Status Changes Successfully');
			getCustomerDetails();
			setIsMarkAsStatusModel(false);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}
	useEffect(() => {
		dispatch(master_data());
	}, [dispatch]);
	useEffect(() => {
		getCustomerDetails();
	}, [id]);

	useEffect(() => {
		getCity(customerData.address.state_id);
	}, [customerData.address.state_id]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	return (
		<div>
			<Header
				headerTitle="Customers Details"
				closeButton={{
					showCloseButton: true,
					handler: () => {
						if (isNotEdit) {
							setProjectTitle('Customers');
							navigate(`/user/${suburl}/customers`);
						} else {
							setProjectTitle('Customer Details');
							getCustomerDetails();
							setIsNotEdit(true);
							setError({});
						}
					},
				}}
				buttons={
					!isNotEdit
						? [
								{
									id: 1,
									className: 'btn-primary mt-0 px-4 ',
									button: 'Save',
									loader: isLoading,
									disabled:
										isLoading ||
										(id
											? !hasPermission('contacts.customers.edit', user?.role?.role_permissions)
											: !hasPermission('contacts.customers.create', user?.role?.role_permissions)),
									handler: () => {
										if (isClone) {
											handleCloneCustomer(1);
										} else {
											handleUpdateCustomer(1);
										}
									},
								},
							]
						: [
								{
									id: 1,
									className: 'btn-primary mt-0 px-4 ',
									button: 'Edit',
									disabled: !hasPermission('contacts.customers.edit', user?.role?.role_permissions),
									handler: () => {
										setProjectTitle('Update Customer');
										setIsNotEdit(false);
									},
								},
								{
									id: 2,
									className: 'btn-gray mt-0 px-4 ',
									disabled: !hasPermission(
										'contacts.customers.clone',
										user?.role?.role_permissions,
									),
									handler: () => {
										setIsNotEdit(false);
										setIsClone(true);
									},
									button: 'Clone',
								},
								{
									id: 3,
									title: 'New Transaction',
									isDropdown: true,
									options: [
										...(hasPermission('sales.invoices.create', user?.role?.role_permissions)
											? [
													{
														id: '1.3',
														handler: () => handleCreateButton(0),
														title: 'Invoice',
													},
												]
											: []),
										...(hasPermission(
											'sales.payments_received.create',
											user?.role?.role_permissions,
										)
											? [
													{
														id: '1.4',
														handler: () => handleCreateButton(1),
														title: 'Payment Received',
													},
												]
											: []),
										...(hasPermission('sales.sales_return.create', user?.role?.role_permissions)
											? [
													{
														id: '1.6',
														handler: () => handleCreateButton(2),
														title: 'Sales Return',
													},
												]
											: []),
										...(hasPermission('sales.credit_note.create', user?.role?.role_permissions)
											? [
													{
														id: '1.31',
														handler: () => handleCreateButton(3),
														title: 'Credit Note',
													},
												]
											: []),
									],
								},
								{
									id: 4,
									className: 'mt-0 btn-gray add-pro',
									loader: isLoader,
									disabled: !hasPermission('contacts.customers.edit', user?.role?.role_permissions),
									button:
										customerData.basicDetails.status === 0 || customerData.basicDetails.status === 2
											? 'Mark as Active'
											: 'Mark as Inactive',
									handler: async () => {
										setIsMarkAsStatusModel(true);
									},
								},
								{
									id: 5,
									className: 'btn-gray add-pro',
									button: 'Delete',
									disabled:
										!customerData.can_delete ||
										!hasPermission('contacts.customers.delete', user?.role?.role_permissions),
									handler: () => setIsDeleteModalOpen(true),
								},
							].filter(Boolean)
				}
				dropDownButtons={[]}
			/>

			<div style={{ backgroundColor: '#EDEDF7', marginTop: '-10px', paddingLeft: '10px' }}>
				<NavigationTabsCustomersDetails
					activeTab={activeTab}
					user={user}
					setActiveTab={setActiveTab}
				/>
			</div>

			<div className="tab-content ">
				{activeTab === 'Information' && (
					<Information
						setCustomerData={setCustomerData}
						setPrescriptionsDocsList={setPrescriptionsDocsList}
						prescriptionsDocsList={prescriptionsDocsList}
						customerData={customerData}
						cityList={cityList}
						customerDocs={customerDocs}
						totalOutStandingAmount={totalOutStandingAmount}
						amountDueFifteenDays={amountDueFifteenDays}
						setCustomerDocs={setCustomerDocs}
						errors={errors}
						setError={setError}
						isEdit={isNotEdit}
					/>
				)}
				{activeTab !== 'Information' && (
					<RenderContent
						activeTabMain={activeTab}
						customerData={{ key: Number(id), value: customerData?.basicDetails.customer_name }}
					/>
				)}
			</div>

			{isMarkAsStatusModel && (
				<ConfirmationModal
					isOpen={isMarkAsStatusModel}
					onClose={() => setIsMarkAsStatusModel(false)}
					title={getModalTitle()}
					content={getModalContent()}
					onCancel={() => setIsMarkAsStatusModel(false)}
					onOk={() => {
						handleIsActiveStatus(
							customerData.basicDetails.status === 0 || customerData.basicDetails.status === 2
								? 1
								: 2,
						);
					}}
					loader={isLoader}
				/>
			)}

			{isDeleteModalOpen && (
				<DeleteModal
					isDeleteBulkConfirmationModalOpen={isDeleteModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteModalOpen}
					selectedListForDelete={[customerData.basicDetails.customer_name]}
					handleBulkDelete={handleBulkDelete}
					deleteLength={1}
					saleTypeName={'Customer'}
				/>
			)}
		</div>
	);
};

export default CustomersDetails;
